export const AI_LINK =
	'https://support.atlassian.com/organization-administration/docs/understand-atlassian-intelligence-features-in-products';
export const ADMIN_LINK = 'http://admin.atlassian.com/';
